const LISTING_ID_KEY = 'currentListingId'
const LISTING_PUBLISHED_KEY = 'currentListingIsPublished'
export const LISTING_CONTEXT_UPDATED_EVENT = 'listing-context-updated'

export function getCurrentListingId() {
  try {
    const id = localStorage.getItem(LISTING_ID_KEY)
    if (!id || id === 'undefined' || id === 'null') return null
    return id
  } catch {
    return null
  }
}

export function isCurrentListingPublished() {
  const id = getCurrentListingId()
  if (!id) return false
  try {
    return localStorage.getItem(LISTING_PUBLISHED_KEY) === 'true'
  } catch {
    return false
  }
}

export function setCurrentListingContext(listingId, isPublished) {
  try {
    if (listingId) {
      localStorage.setItem(LISTING_ID_KEY, String(listingId))
      localStorage.setItem(LISTING_PUBLISHED_KEY, isPublished ? 'true' : 'false')
    } else {
      localStorage.removeItem(LISTING_ID_KEY)
      localStorage.removeItem(LISTING_PUBLISHED_KEY)
    }
    window.dispatchEvent(new CustomEvent(LISTING_CONTEXT_UPDATED_EVENT))
  } catch {
    /* ignore */
  }
}

export function clearCurrentListingContext() {
  setCurrentListingContext(null, false)
}
